/**
 * BillingHistoryCard Component
 * Expandable card showing invoice history
 *
 * Features:
 * - Recent invoices with download links
 * - Default collapsed
 * - Link to Stripe Customer Portal for full history
 *
 * NOTE: This is a placeholder - actual invoice data would come from backend
 */

import { Card, Collapse, Typography, Button } from 'antd'
import { useStripeCheckout } from '@/hooks/useStripeCheckout'

const { Text } = Typography

export function BillingHistoryCard() {
  const { openPortal, loading } = useStripeCheckout()

  return (
    <Card>
      <Collapse
        ghost
        items={[
          {
            key: 'billing-history',
            label: 'Billing History',
            children: (
              <div>
                <Text type="secondary" style={{ display: 'block', marginBottom: '16px' }}>
                  View and download your invoices in the Stripe Customer Portal.
                </Text>
                <Button onClick={openPortal} loading={loading}>
                  View Billing History in Stripe
                </Button>
              </div>
            )
          }
        ]}
      />
    </Card>
  )
}
